import { render, staticRenderFns } from "./relate-contract.vue?vue&type=template&id=063689fb&scoped=true&"
import script from "./relate-contract.vue?vue&type=script&lang=js&"
export * from "./relate-contract.vue?vue&type=script&lang=js&"
import style0 from "./relate-contract.vue?vue&type=style&index=0&id=063689fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063689fb",
  null
  
)

export default component.exports